import { Container, Row, Col } from 'react-bootstrap';
import { litrals } from '../../../../../../../constants/Litrals';

const HowToConfigure = () => {
  return (
    <Container className="subscriber-container">
      <Row className="justify-content-center">
        <Col xs={12} md={8}>
          <h3 data-testid="how-to-configure">
            {litrals.subscriberHowToConfigure}
          </h3>
          <div className="subscriber-content">
            <p>
              Subscribers need to provide an Endpoint URL, Username and Password
              for each data feed required.
            </p>
            <h6>Step-by-step instructions on configuring feed.</h6>

            <h6>Links to Technical Specifications</h6>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default HowToConfigure;
